module.exports = __webpack_public_path__ + "static/img/noticia2.ef2869c0.jpg";